// utils/authUtils.js

// Get tokens
export const getAuthToken = () => localStorage.getItem("auth_token");
export const getRefreshToken = () => localStorage.getItem("refresh_token");
export const getOtpToken = () => localStorage.getItem("otp_token");

// Set tokens
export const setAuthToken = (token) => {
  if (token) localStorage.setItem("auth_token", token);
};
export const setRefreshToken = (token) => {
  if (token) localStorage.setItem("refresh_token", token);
};
export const setOtpToken = (token) => {
  if (token) localStorage.setItem("otp_token", token);
};

// Set all auth data
export const setAuthData = (data) => {
  if (data.access_token) setAuthToken(data.access_token);
  if (data.refresh_token) setRefreshToken(data.refresh_token);
  if (data.user) setUserData(data.user);
};

// Clear all auth data
export const clearAuthData = () => {
  localStorage.removeItem("auth_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user_data");
  localStorage.removeItem("otp_token");
};

// User data
export const getUserData = () => {
  try {
    const data = localStorage.getItem("user_data");
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

export const setUserData = (user) => {
  if (user) localStorage.setItem("user_data", JSON.stringify(user));
};

// Check auth status
export const isAuthenticated = () => {
  return !!(getAuthToken() && getUserData());
};
